<button type="button" (click)="onCardClick()" class="vacancy-card vacancy-card--vacatures">
  <span *ngIf="vacancy.isNew" class="vacancy-tag vacancy-tag--new mb-2">{{ 'vacancies.card.new' | translate }}</span>

  <ng-container *ngIf="!hideMatchBar">
    <span
      *ngIf="isSurpriseMe; else matchBar"
      [class]="'match-circle match-circle--card match-circle--' + matchColor(vacancy.matchScore)"
    ></span>
    <ng-template #matchBar>
      <div class="vacancy-match-bar">
        <div class="vacancy-match-bar__fill" [style.width.%]="vacancy.matchScore">
          <span class="vacancy-match-bar__label">{{ vacancy.matchScore | number: '1.0-0' }}%</span>
        </div>
      </div>
    </ng-template>
  </ng-container>

  <p class="vacancy-card__subtitle">{{ vacancy.company }}</p>

  <h3 class="vacancy-card__title">{{ vacancy.title }}</h3>

  <div class="vacancy-card__location">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
    {{ vacancy.location }}
  </div>

  <div class="vacancy-card__footer">
    <div class="vacancy-tags">
      <span *ngFor="let tag of vacancy.tags" class="vacancy-tag">{{ tag }}</span>
    </div>
    <div class="vacancy-card__actions">
      <button
        class="vacancy-btn-round vacancy-btn-heart"
        [class.greyed-out]="(isActivated$ | async) === false"
        [matTooltip]="(isActivated$ | async) === false ? ('global.tooltip_save_vacancy_not_activated' | translate) : ''"
        [class.vacancy-btn-heart--active]="isLiked"
        (click)="onLike($event)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          [attr.fill]="isLiked ? 'currentColor' : 'none'"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
          />
        </svg>
      </button>
      <span class="vacancy-btn-round vacancy-btn-arrow">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M5 12h14" />
          <path d="m12 5 7 7-7 7" />
        </svg>
      </span>
    </div>
  </div>
</button>
